import WebsiteBuilders from "components/atoms/WebsiteBuilders";
import React from "react";

const WebsiteBuilder = () => {
    return <WebsiteBuilders />;
};

export default WebsiteBuilder;
